import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import * as Tooltip from '@radix-ui/react-tooltip';


// ---------------------------------------------------------
// Color Styles
// ---------------------------------------------------------

const colorStyles = {
  blue: {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    border: 'border-blue-200 dark:border-blue-800',
    title: 'text-blue-700 dark:text-blue-300',
    value: 'text-blue-900 dark:text-blue-200',
  },

  purple: {
    bg: 'bg-purple-50 dark:bg-purple-900/20',
    border: 'border-purple-200 dark:border-purple-800',
    title: 'text-purple-700 dark:text-purple-300',
    value: 'text-purple-900 dark:text-purple-200',
  },

  green: {
    bg: 'bg-green-50 dark:bg-green-900/20',
    border: 'border-green-200 dark:border-green-800',
    title: 'text-green-700 dark:text-green-300',
    value: 'text-green-900 dark:text-green-200',
  },

  yellow: {
    bg: 'bg-yellow-50 dark:bg-yellow-900/20',
    border: 'border-yellow-200 dark:border-yellow-800',
    title: 'text-yellow-700 dark:text-yellow-300',
    value: 'text-yellow-900 dark:text-yellow-200',
  },

  indigo: {
    bg: 'bg-indigo-50 dark:bg-indigo-900/20',
    border: 'border-indigo-200 dark:border-indigo-800',
    title: 'text-indigo-700 dark:text-indigo-300',
    value: 'text-indigo-900 dark:text-indigo-200',
  },

  cyan: {
    bg: 'bg-cyan-50 dark:bg-cyan-900/20',
    border: 'border-cyan-200 dark:border-cyan-800',
    title: 'text-cyan-700 dark:text-cyan-300',
    value: 'text-cyan-900 dark:text-cyan-200',
  },

  rose: {
    bg: 'bg-rose-50 dark:bg-rose-900/20',
    border: 'border-rose-200 dark:border-rose-800',
    title: 'text-rose-700 dark:text-rose-300',
    value: 'text-rose-900 dark:text-rose-200',
  },

  emerald: {
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    border: 'border-emerald-200 dark:border-emerald-800',
    title: 'text-emerald-700 dark:text-emerald-300',
    value: 'text-emerald-900 dark:text-emerald-200',
  },
};


// ---------------------------------------------------------
// Ranked KPI Component
// ---------------------------------------------------------

export default function RankedKPI({
  title,
  label,
  value,

  color = 'blue',

  id,

  // Optional tooltip
  tooltipContent,
  showTooltip = false,
}) {
  const styles =
    colorStyles[color] || colorStyles.blue;

  return (
    <Tooltip.Provider delayDuration={200}>
      <Box sx={{ minWidth: 0 }}>

<Card 
  id={id}
  variant="outlined"
  className={`
    ${styles.bg} 
    ${styles.border} 
    rounded-lg 
    shadow-sm
    h-[130px]
  `}
>

<CardContent className="p-4 h-full flex flex-col justify-between">

            {/* KPI Title */}
            <Typography
              component="h4"
              className={`
                ${styles.title}
                text-sm
                font-medium
              `}
            >
              {title}
            </Typography>


            {/* Ranked Item */}
            <Typography
              component="p"
              className={`
                ${styles.value}
                text-md
                font-semibold
                mt-1
                truncate
              `}
            >
              {label || '-'}
            </Typography>


            {/* Ranked Value */}
            <Typography
              component="p"
              className={`
                ${styles.value}
                text-lg
                font-bold
              `}
            >
              {value !== undefined && value !== null
                ? Number(value).toLocaleString()
                : '-'}
            </Typography>


            {/* Optional "View all" Tooltip */}
            {showTooltip && tooltipContent && (
              <Tooltip.Root>

                {/* Tooltip Trigger */}
                <Tooltip.Trigger asChild>
                  <button
                    type="button"
                    className={`
                      ${styles.title}
                      text-xs
                      underline
                      cursor-help
                      mt-1
                    `}
                  >
                    View all
                  </button>
                </Tooltip.Trigger>


                {/* Tooltip */}
                <Tooltip.Portal>

                  <Tooltip.Content
                    side="top"
                    sideOffset={5}
                    className="
                      bg-black
                      text-white
                      text-xs
                      rounded
                      px-3
                      py-2
                      shadow-md
                      z-[9999]
                      max-w-[250px]
                    "
                  >

                    {tooltipContent}

                    <Tooltip.Arrow className="fill-black" />

                  </Tooltip.Content>

                </Tooltip.Portal>

              </Tooltip.Root>
            )}

          </CardContent>

        </Card>

      </Box>
    </Tooltip.Provider>
  );
}

